var _path, _path2, _path3, _path4, _g, _g2, _defs;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFunds = function SvgFunds(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.001 15C30.001 6.71573 23.2852 -2.92514e-06 15.001 -2.56302e-06C6.7167 -2.2009e-06 0.000975545 6.71573 0.000975907 15C0.000976269 23.2843 6.71671 30 15.001 30C23.2852 30 30.001 23.2843 30.001 15Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.001 30.001C23.2852 30.001 30.001 23.2852 30.001 15.001C30.001 6.71671 23.2852 0.000976563 15.001 0.000976563C6.71671 0.000976563 0.000976562 6.71671 0.000976562 15.001C0.000976562 23.2852 6.71671 30.001 15.001 30.001Z",
    fill: "url(#paint0_radial_1979_135565)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.001 15C30.001 6.71573 23.2852 -1.01779e-06 15.001 -6.55671e-07C6.7167 -2.93554e-07 0.000975545 6.71573 0.000975907 15C0.000976269 23.2843 6.71671 30 15.001 30C23.2852 30 30.001 23.2843 30.001 15Z",
    fill: "url(#paint1_linear_1979_135565)",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.001 15C30.001 6.71573 23.2852 -1.01779e-06 15.001 -6.55671e-07C6.7167 -2.93554e-07 0.000975545 6.71573 0.000975907 15C0.000976269 23.2843 6.71671 30 15.001 30C23.2852 30 30.001 23.2843 30.001 15Z",
    fill: "url(#paint2_radial_1979_135565)",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1979_135565)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1875 13.625C12.086 13.625 13.625 12.086 13.625 10.1875C13.625 8.28902 12.086 6.75 10.1875 6.75C8.28902 6.75 6.75 8.28902 6.75 10.1875C6.75 12.086 8.28902 13.625 10.1875 13.625Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8125 23.25C21.711 23.25 23.25 21.711 23.25 19.8125C23.25 17.914 21.711 16.375 19.8125 16.375C17.914 16.375 16.375 17.914 16.375 19.8125C16.375 21.711 17.914 23.25 19.8125 23.25Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.4375 10.875H20.5V14.3125H21.875V10.1875C21.875 9.808 21.567 9.5 21.1875 9.5H18.4375V7.4375L15 10.1875L18.4375 12.9375V10.875Z",
    fill: "#001947"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 19.125H9.5V15.6875H8.125V19.8125C8.125 20.192 8.433 20.5 8.8125 20.5H11.5625V22.5625L15 19.8125L11.5625 17.0625V19.125Z",
    fill: "#001947"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1979_135565)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.62503 22.5001C12.3591 22.5001 20.25 14.6092 20.25 4.87514C20.25 3.46339 20.0841 2.09042 19.7705 0.774658C25.7161 2.76765 30 8.38361 30 15.0001C30 23.2844 23.2843 30.0001 15 30.0001C9.44343 30.0001 4.59251 26.9788 2.00049 22.4893C2.20778 22.4965 2.41598 22.5001 2.62503 22.5001Z",
    fill: "url(#paint3_linear_1979_135565)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1979_135565",
    x: 0.667155,
    y: -0.558675,
    width: 30.6662,
    height: 31.8923,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 0.666667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1979_135565"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1979_135565",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1979_135565",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9456 -4.75482e-05) rotate(135) scale(26.2404)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1979_135565",
    x1: 13.751,
    y1: -2.5,
    x2: 0.000974612,
    y2: 17.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.270833,
    stopColor: "#00F47F",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1979_135565",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5002 7.125) rotate(143.291) scale(35.5496 29.3442)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.610268,
    stopColor: "#00BDE7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1979_135565",
    x1: 16.0041,
    y1: 30.0001,
    x2: 19.7477,
    y2: 8.84747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F47F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DFED",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1979_135565"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 16.5,
    fill: "white",
    transform: "translate(6.75 6.75)"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFunds, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/funds.9c229af6.svg";
export { ForwardRef as ReactComponent };